import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import { Formik } from "formik";
import React, { Component } from "react";
import { connect } from "react-redux";
import LoginBox from "../../components/login/LoginBox";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import { signUp } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import * as utils from "../../../_metronic/utils/utils";
import {
  getInitialValuesRegister,
  validateFormRegisterStep1,
  validateFormRegisterStep2,
  createFormRegister,
} from "./RegisterUtils";
import { formatCPForCNPJInput, formatTelefoneInput } from "../../utils/Utils";
import styles from "../../styles/ForgotPassword.module.scss";
import registerStyles from "../../styles/Register.module.scss";
import Swal from "sweetalert2";

class Register extends Component {
  state = {
    step: 1,
    loading: false,
    mostrarSenha: false,
    mostrarSenhaConfirm: false,
    verificacao: {
      oitoCarac: false,
      letraMaiuscula: false,
      letraMinuscula: false,
      numero: false,
      caractereEspecial: false,
    },
  };

  handleShow = (marcador) => {
    this.setState((prevState) => ({
      [marcador]: !prevState[marcador],
    }));
  };

  verificarSenha = (senha) => {
    this.setState({
      verificacao: {
        oitoCarac: senha.length >= 8,
        letraMaiuscula: /[A-Z]/.test(senha),
        letraMinuscula: /[a-z]/.test(senha),
        numero: /\d/.test(senha),
        caractereEspecial: /[!@#$%&/+\-=[\]{}()*_.,;:<>?]/.test(senha),
      },
    });
  };

  handleContinuarStep1 = (values, setErrors) => {
    const step1Values = {
      razao_social: values.razao_social,
      cnpj: values.cnpj,
      email: values.email,
      telefone: values.telefone,
    };
    
    const err = validateFormRegisterStep1(step1Values);
    
    if (Object.keys(err).length > 0) {
      setErrors(err);
      
      const first = Object.values(err)[0];
      
      Swal.fire("Ops!", first, "warning");
    } else {
      this.setState({ step: 2 });
    }
  };

  handleContinuarStep2 = (values, setErrors) => {
    const err = validateFormRegisterStep2(values);
    
    if (Object.keys(err).length > 0) {
      setErrors(err);
      
      const first = Object.values(err)[0];
      
      Swal.fire("Ops!", first, "warning");
      
      return;
    }
    
    this.setState({ loading: true });
    const data = createFormRegister(values);
    
    signUp(data)
      .then((response) => {
        utils.setStorage("authToken", response.data.token, null);
        this.props.login(response.data);
      })
      .then(() => {
        this.props.history.push("/inicio");
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Erro ao criar conta. Tente novamente.";
        Swal.fire("Ops!", msg, "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { step, loading, mostrarSenha, mostrarSenhaConfirm, verificacao } = this.state;

    return (
      <div className="login-inner flex-column">
        <Formik
          initialValues={getInitialValuesRegister()}
          onSubmit={() => {}}
        >
          {({ values, setFieldValue, setErrors, handleChange, handleBlur, touched, errors }) => (
            <>
              {step === 1 && (
                <LoginBox
                  loading={loading}
                  titulo={"Cadastre-se"}
                  subtitulo={"Insira os dados solicitados abaixo para criar sua conta."}
                  voltar={"/auth/login"}
                  size={"small"}
                  customClass={"senha"}
                >
                  <div className="flex-column" style={{ gap: "40px", width: "100%" }}>
                    <div className={registerStyles.formFields}>
                      <InputCustom
                        label={"Razão social"}
                        name={"razao_social"}
                        type={"text"}
                        value={values.razao_social}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                      />

                      <InputCustom
                        label={"CNPJ"}
                        name={"cnpj"}
                        type={"text"}
                        value={values.cnpj}
                        onChange={(e) => setFieldValue("cnpj", formatCPForCNPJInput(e).target.value)}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                        maxLength={18}
                      />

                      <InputCustom
                        label={"E-mail"}
                        name={"email"}
                        type={"email"}
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                      />

                      <InputCustom
                        label={"Telefone"}
                        name={"telefone"}
                        type={"tel"}
                        value={values.telefone}
                        onChange={(e) => setFieldValue("telefone", formatTelefoneInput(e).target.value)}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                        maxLength={15}
                      />
                    </div>

                    <p className={registerStyles.disclaimer}>
                      Ao continuar, você concorda com nossos{" "}
                      <a href="/termos" target="_blank" rel="noopener noreferrer">
                        Termos de Serviço
                      </a>{" "}
                      e{" "}
                      <a href="/privacidade" target="_blank" rel="noopener noreferrer">
                        Políticas de Privacidade
                      </a>
                      .
                    </p>

                    <Button
                      type="button"
                      disabled={loading}
                      variant="primary"
                      size="lg"
                      height="lg"
                      fullWidth={true}
                      loading={loading}
                      children="Continuar"
                      onClick={() => this.handleContinuarStep1(values, setErrors)}
                    />
                  </div>
                </LoginBox>
              )}

              {step === 2 && (
                <LoginBox
                  loading={loading}
                  titulo={"Criar senha"}
                  subtitulo={"Crie uma senha para acessar sua conta."}
                  size={"small"}
                  customClass={"senha"}
                  voltar={() => this.setState({ step: 1 })}
                >
                  <div className="flex-column" style={{ gap: "24px" }}>
                    <div>
                      <InputCustom
                        label={"Digite sua senha"}
                        name={"senha"}
                        type={mostrarSenha ? "text" : "password"}
                        value={values.senha}
                        onChange={(e) => {
                          const valor = e.target.value;
                          setFieldValue("senha", valor);
                          this.verificarSenha(valor);
                        }}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                        icon_left={mostrarSenha ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                        icon_style={{ cursor: "pointer" }}
                        onIconClick={() => this.handleShow("mostrarSenha")}
                      />
                    </div>

                    <div>
                      <InputCustom
                        label={"Confirme sua senha"}
                        name={"senhaConfirm"}
                        type={mostrarSenhaConfirm ? "text" : "password"}
                        value={values.senhaConfirm}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={loading}
                        required
                        errors={errors}
                        touched={touched}
                        icon_left={mostrarSenhaConfirm ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                        icon_style={{ cursor: "pointer" }}
                        onIconClick={() => this.handleShow("mostrarSenhaConfirm")}
                      />
                    </div>
                      
                  </div>

                  <div className={`deve-conter ${styles.requirements}`}>
                    <p className={styles.title}>Sua senha deve conter:</p>
                    
                    <div className={`${styles.row} ${verificacao.oitoCarac ? styles.met : ""}`}>
                      <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                      <span>No mínimo 8 caracteres</span>
                    </div>
                    
                    <div className={`${styles.row} ${verificacao.letraMinuscula ? styles.met : ""}`}>
                      <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                      <span>Ao menos 1 letra minúscula</span>
                    </div>
                    
                    <div className={`${styles.row} ${verificacao.letraMaiuscula ? styles.met : ""}`}>
                      <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                      <span>Ao menos 1 letra maiúscula</span>
                    </div>
                    
                    <div className={`${styles.row} ${verificacao.numero ? styles.met : ""}`}>
                      <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                      <span>Ao menos 1 número (0123456789)</span>
                    </div>
                    
                    <div className={`${styles.row} ${verificacao.caractereEspecial ? styles.met : ""}`}>
                      <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                      <span>Ao menos 1 caractere especial (*!@#$%&/+-=)</span>
                    </div>
                  </div>

                  <Button
                    type="button"
                    disabled={loading}
                    variant="primary"
                    size="lg"
                    height="lg"
                    fullWidth={true}
                    loading={loading}
                    children="Continuar"
                    onClick={() => this.handleContinuarStep2(values, setErrors)}
                  />
                </LoginBox>
              )}
            </>
          )}
        </Formik>
      </div>
    );
  }
}

export default connect(null, auth.actions)(Register);
